function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5852 87.8773C24.5851 87.0614 23.9534 86.4 23.1743 86.3999C22.3951 86.3998 21.7635 87.0612 21.7636 87.877L21.7636 88.7196C21.7637 89.5149 21.1188 90.1596 20.3233 90.1595L19.4783 90.1595C18.6617 90.1594 17.9998 90.7909 17.9999 91.5699C18 92.3489 18.662 92.9805 19.4785 92.9805L20.324 92.9806C21.1193 92.9807 21.764 93.6252 21.7641 94.4203L21.7641 95.2633C21.7642 96.0791 22.3959 96.7406 23.1751 96.7406C23.9543 96.7407 24.5859 96.0794 24.5858 95.2635L24.5857 94.421C24.5857 93.6257 25.2305 92.981 26.026 92.9811L26.8708 92.9811C27.6874 92.9812 28.3492 92.3497 28.3492 91.5707C28.3491 90.7917 27.6871 90.1601 26.8706 90.1601L26.0253 90.16C25.23 90.1599 24.5853 89.5154 24.5853 88.7203L24.5852 87.8773Z",
  fill: "#FFD500"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.2981 76.4673L122.4 30.2397L49.2102 111.403C48.8408 111.812 48.1669 111.671 47.9924 111.148L37.2894 79.0434C36.9595 78.0538 37.3839 76.9698 38.2981 76.4673Z",
  fill: "#CBCBCB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48.9598 111.6L64.7998 95.6426L56.5198 91.7998L48.9598 111.6Z",
  fill: "#DEDEDE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3796 68.3205L37.9142 81.5497L114.249 35.445C114.988 34.9985 115.744 35.9946 115.114 36.586L56.3208 91.8315L85.6779 108.953C86.7843 109.599 88.206 109.145 88.734 107.978L122.546 33.2515C123.319 31.5426 121.696 29.728 119.912 30.3063L14.772 64.3828C12.9809 64.9633 12.7383 67.3979 14.3796 68.3205Z",
  fill: "#EDEDED"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.684 22.6287C42.6839 21.2653 41.6283 20.16 40.3262 20.1599C39.0242 20.1598 37.9687 21.2649 37.9688 22.6283L37.969 25.0034C37.9691 25.7987 37.3242 26.4434 36.5287 26.4433L34.1503 26.4432C32.7858 26.443 31.6798 27.4983 31.6799 28.8001C31.68 30.1018 32.7862 31.1572 34.1507 31.1573L36.5296 31.1575C37.3249 31.1576 37.9696 31.8021 37.9696 32.5972L37.9698 34.9712C37.9699 36.3345 39.0255 37.4398 40.3276 37.4399C41.6296 37.44 42.6851 36.3349 42.685 34.9715L42.6848 32.5981C42.6847 31.8028 43.3296 31.1581 44.1251 31.1581L46.5038 31.1583C47.8682 31.1584 48.9743 30.1032 48.9742 28.8014C48.9741 27.4996 47.8679 26.4442 46.5034 26.4441L44.1242 26.4439C43.3289 26.4439 42.6842 25.7993 42.6842 25.0042L42.684 22.6287Z",
  fill: "#FFD500"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M129.705 66.9971C129.705 66.1813 129.073 65.5198 128.294 65.5198C127.515 65.5197 126.883 66.1811 126.883 66.9969L126.883 67.8395C126.883 68.6348 126.239 69.2795 125.443 69.2794L124.598 69.2793C123.782 69.2793 123.12 69.9108 123.12 70.6898C123.12 71.4688 123.782 72.1004 124.598 72.1004L125.444 72.1005C126.239 72.1006 126.884 72.7451 126.884 73.5402L126.884 74.3831C126.884 75.199 127.516 75.8604 128.295 75.8605C129.074 75.8606 129.706 75.1992 129.706 74.3834L129.706 73.5409C129.705 72.7456 130.35 72.1009 131.146 72.1009L131.991 72.101C132.807 72.1011 133.469 71.4696 133.469 70.6906C133.469 69.9116 132.807 69.28 131.99 69.2799L131.145 69.2799C130.35 69.2798 129.705 68.6353 129.705 67.8402L129.705 66.9971Z",
  fill: "#FFD500"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M114.479 86.4001C124.818 86.4001 133.199 94.7814 133.199 105.12C133.199 115.459 124.818 123.84 114.479 123.84C104.141 123.84 95.7595 115.459 95.7595 105.12L95.7595 86.4001L114.479 86.4001Z",
  fill: "#47D1A7"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M110.409 112.686C111.051 113.329 112.093 113.329 112.736 112.686L124.373 101.049C125.016 100.407 125.016 99.3646 124.373 98.7219L123.209 97.5582C122.567 96.9155 121.525 96.9155 120.882 97.5582L111.574 106.866L108.064 103.356C107.421 102.714 106.379 102.714 105.736 103.356L104.572 104.52C103.93 105.163 103.93 106.205 104.572 106.847L109.191 111.466C109.208 111.485 109.226 111.504 109.245 111.523L110.409 112.686Z",
  fill: "white"
});

var SvgEmailSuccessSend = function SvgEmailSuccessSend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailSuccessSend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email-success-send.c4ad163b.svg";
export { ForwardRef as ReactComponent };